import React from "react";

import HeaderMobileMenuButton from "@components/UI/Header/HeaderMobileMenuButton";

function UserHeaderMobile({ toggleMobileMenu, showMobileMenu }) {
  return (
    <div className="header-mobile-buttons">
      <HeaderMobileMenuButton
        toggleMobileMenu={toggleMobileMenu}
        showMobileMenu={showMobileMenu}
      />
    </div>
  );
}

export default UserHeaderMobile;
